<template>
  <div>
    <ds-heading text="Funcionários" />

    <ds-row v-if="shouldShowWorkersTable">
      <ds-col size="2">
        <ds-button
          theme="primary"
          @click="onNew">
          Novo funcionário
        </ds-button>
      </ds-col>
    </ds-row>

    <ds-row vertical-offset="2">
      <ds-col>
        <ds-page>
          <ds-data-grid
            v-if="shouldShowWorkersTable"
            ref="dataGrid"
            :filters="filters"
            :columns="columns"
            :pagination="pagination"
            :search-term-placeholder="placeholder"
            show-search-term-filter
            :fetch-action="getWorkers"
            @fetch-success="setWorkers">
            <ds-data-grid-tr
              v-for="(worker, index) in workers"
              :key="worker.id"
              :view-action="onView"
              :item="worker">
              <ds-td>
                {{ worker.registration }}
              </ds-td>
              <ds-td>
                {{ worker.name }}
              </ds-td>
              <ds-td>
                <ds-badge
                  v-ds-tooltip="getDeniedMessage(worker)"
                  :theme="getStatusColor(worker)">
                  {{ getStatusDescription(worker) }}
                  <ds-icon
                    v-if="!!getDeniedMessage(worker)"
                    name="comment"
                    size="sm">
                  </ds-icon>
                </ds-badge>
              </ds-td>
              <ds-td>
                <ds-badge
                  v-ds-tooltip="getDeniedMessage(worker.personalData)"
                  :theme="getStatusColor(worker.personalData)">
                  {{ getStatusDescription(worker.personalData) }}
                  <ds-icon
                    v-if="!!getDeniedMessage(worker.personalData)"
                    name="comment"
                    size="sm">
                  </ds-icon>
                </ds-badge>
              </ds-td>
              <ds-td align="right">
                <ds-row>
                  <ds-col size="fill">
                    <ds-button
                      v-if="shouldShowApproveButton(worker)"
                      size="sm"
                      @click="onView(worker)">
                      Aprovar
                    </ds-button>
                  </ds-col>
                  <ds-col size="fill">
                    <worker-actions-page-dropdown
                      v-if="shouldShowActionsDropdown(worker)"
                      :contract-data-status="worker.workflowTask"
                      :personal-data="worker.personalData"
                      @on-delete="onDelete(worker.id, index)"
                      @on-edit-contract="onEditContract(worker.id)"
                      @on-add-personal="onAddPersonalData(worker)"
                      @on-edit-personal="onEditPersonalData(worker.id)">
                      <ds-dropdown-item
                        v-if="shouldShowHistory"
                        @click="onJobDescriptionsHistory(worker.id)">
                        Histórico de Funções
                      </ds-dropdown-item>
                    </worker-actions-page-dropdown>
                  </ds-col>
                </ds-row>
              </ds-td>
            </ds-data-grid-tr>
          </ds-data-grid>
          <worker-blankslate-page v-else @on-new="onNew" />
        </ds-page>
      </ds-col>
    </ds-row>
  </div>
</template>

<script>
import { isStatusPending } from 'accountant/worker/src/services/approvalService';
import { isUserAccountant } from 'packages/common';
import {
  getStatusColor,
  getStatusDescription,
  getDeniedMessage,
  hasStatusPending,
  shouldShowActionsDropdown,
  setWorkerDraft,
  getWorkersSortedAndPaginated,

} from './workersService';
import { CommonCrudMixin } from './mixins/CommonCrudMixin';
import WorkerViewRollover from './modals/worker-view-rollover/WorkerViewRollover';
import WorkerActionsPageDropdown from './components/WorkerActionsPageDropdown';
import { TABS_INDEX } from './modals/worker-view-rollover/workerViewRolloverConstants';
import EditPendingContractlDataAlert from './modals/EditPendingContractlDataAlert';
import WorkerBlankslatePage from './WorkerBlankslatePage';
import {
  TABLE_HEADER_COLUMNS, DEFAULT_PAGINATION,
} from './constants';

export default {
  name: 'WorkerPage',
  components: {
    WorkerActionsPageDropdown,
    WorkerBlankslatePage,
  },
  mixins: [
    CommonCrudMixin,
  ],
  data() {
    return {
      workers: {},
      filters: {
        searchTerm: '',
      },
      placeholder: 'Pesquisar matrícula/nome',
      pagination: {
        ...DEFAULT_PAGINATION,
      },
      columns: TABLE_HEADER_COLUMNS,
      loading: false,
    };
  },
  computed: {
    shouldShowHistory() {
      return isUserAccountant();
    },
    shouldShowWorkersTable() {
      return this.loading || (this.workers?.length > 0 || isUserAccountant());
    },
  },
  created() {
    this.initData();
  },
  methods: {
    shouldShowActionsDropdown,
    getStatusColor,
    getStatusDescription,
    getDeniedMessage,
    initData() {
      this.$store.dispatch('worker/clearWorkerBasicInfo');
      this.$store.dispatch('breadcrumb/setBreadcrumbProps', { workerName: null });
      this.loading = true;
    },
    shouldShowApproveButton(worker) {
      return isUserAccountant() && hasStatusPending(worker);
    },
    getWorkers(filters) {
      return getWorkersSortedAndPaginated(filters);
    },
    setWorkers({ content, totalElements }) {
      this.workers = content;
      this.loading = false;
      this.setPagination({ totalItems: totalElements });
    },
    setPagination({ totalItems = 0 }) {
      this.pagination.totalItems = totalItems;
    },
    updateList() {
      this.$refs.dataGrid.refreshTable();
    },
    onDelete(id, index) {
      this.onDeletePageMixin(id, index);
    },
    onDeleteSuccess(index) {
      this.$delete(this.workers, index);
    },
    onJobDescriptionsHistory(workerId) {
      this.$router.push({
        name: 'WorkerChangeJobDescriptions',
        params: { id: workerId },
      });
    },
    onNew() {
      setWorkerDraft({}, true);
      this.$router.push({ name: 'NewWorker' });
    },
    onView({ id }) {
      if (id) {
        this.$dialogModal(WorkerViewRollover, {
          props: {
            workerId: id,
            activeTabProp: TABS_INDEX.CONTRACT,
          },
          on: {
            'update-list': this.updateList,
            close: this.updateList,
          },
        }).open();
      }
    },
    openContractData(workerId, editMode = false) {
      this.$dialogModal(WorkerViewRollover, {
        props: {
          workerId,
          editModeContract: editMode,
          activeTabProp: TABS_INDEX.CONTRACT,
        },
        on: {
          'update-list': this.updateList,
        },
      }).open();
    },
    onEditContract(workerId) {
      this.openContractData(workerId, true);
    },
    openPersonalData(workerId, editMode = false) {
      this.$dialogModal(WorkerViewRollover, {
        props: {
          workerId,
          editModePersonal: editMode,
          activeTabProp: TABS_INDEX.PERSONAL,
        },
      }).open();
    },
    onAddPersonalData(worker) {
      if (isStatusPending(worker.workflowTask) && isUserAccountant()) {
        this.$dialogModal(EditPendingContractlDataAlert, {
          on: {
            'on-view-contract-data': () => {
              this.openContractData(worker.id, false);
            },
          },
        }).open();
      } else {
        this.$router.push({
          name: 'WorkerRegistrationForm',
          params: {
            id: worker.id,
          },
        });
      }
    },
    onEditPersonalData(workerId) {
      this.openPersonalData(workerId, true);
    },
  },
};
</script>
